<div class="relative flex flex-col items-center">
    <div class="main-background -mt-20 w-full">
        <div class="background-overlay flex flex-col justify-center gap-4 px-5 lg:px-27 h-full text-white">
            <h1 class="h2-text sm:h1-text text-left" i18n>Easy and Convenient<br/>Horse Transportation</h1>
            <h2 class="h3-text sm:h2-text text-left" i18n>Anywhere you need</h2>
        </div>
    </div>
    <div class="absolute top-[70%] lg:top-[92%] 
        w-11/12 sm:w-1/2 lg:w-auto
        flex flex-col lg:flex-row justify-center items-center p-4 gap-4 
        bg-white rounded-2xl shadow-xl">
        <mat-form-field subscriptSizing="dynamic" class="w-full lg:w-52">
            <img matPrefix src="assets/icons/dark/map-pin.svg" class="prefix-icon" alt="icon"/>
            <input id="sourceAddressInputHome" 
            i18n-placeholder="Start location preposition"
            placeholder="From" 
            matInput type="text"
            [matAutocomplete]="acSrc"
            (keyup)="onSourceAddrTxtKeyUp($event)"/>
            <mat-autocomplete #acSrc="matAutocomplete" [displayWith]="addressDisplayFn" (optionSelected)="onSourceSelected($event)">
                <mat-option *ngFor="let option of filteredSourceOptions$ | async" [value]="option">
                    <div class="flex flex-col">
                        <span class="font-bold">{{option.text}}</span>
                        <span class="text-sm">{{option.place_name.slice(option.text.length + 2)}}</span>
                    </div>
                </mat-option>
                </mat-autocomplete>
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic" class="w-full lg:w-52" >
            <img matPrefix src="assets/icons/dark/map-pin.svg" class="prefix-icon" alt="icon"/>
            <input id="destinationAddressInputHome" 
            i18n-placeholder="Destination preposition"
            placeholder="To" 
            matInput type="text"
            [matAutocomplete]="acDest" 
            (keyup)="onDestinationAddrTxtKeyUp($event)"/>
            <mat-autocomplete #acDest="matAutocomplete" [displayWith]="addressDisplayFn" (optionSelected)="onDestinationSelected($event)">
                <mat-option *ngFor="let option of filteredDestinationOptions$ | async" [value]="option">
                    <div class="flex flex-col">
                        <span class="font-bold">{{option.text}}</span>
                        <span class="text-sm">{{option.place_name.slice(option.text.length + 2)}}</span>
                    </div>
                </mat-option>
                </mat-autocomplete>
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic" class="w-full lg:w-52">
            <input matInput title="departureDate" [min]="minDate" 
                [matDatepicker]="departurePicker" 
                [(ngModel)]="travelDate"
                i18n-placeholder="Time question clause" placeholder="When">
            <mat-datepicker-toggle matIconPrefix [for]="departurePicker"></mat-datepicker-toggle>
            <mat-datepicker #departurePicker></mat-datepicker>
        </mat-form-field>
        <button (click)="navigateToSearchRides()"
          class="primary-button w-full lg:w-auto"
          type="button" i18n>Search rides</button>
        <span class="body-m-text" i18n="@@or-preposition">or</span>
        <button (click)="navigateToSearchRequests()"
          class="primary-button w-full lg:w-auto"
          type="button" i18n>Search requests</button>
    </div>
</div>

<div class="bg-blue-50 px-5 lg:px-27 text-center rounded-lg shadow-lg pt-72 lg:pt-27 pb-16 lg:pb-20">
    <!-- class="px-5 md:px-12 lg:px-27 py-12 md:pt-14 md:pb-27 bg-white roboto-font" -->
    <h2 class="text-text-primary h3-text md:h2-text text-center mb-4" i18n>How It Works</h2>
    <div class="flex justify-center items-baseline gap-6 h-10 mb-[60px]">
        <h4 class="h4-text cursor-pointer text-center" [ngClass]="howItWorksIndex == 0 ? 'selectedHowItWorks' : 'text-text-primary'"
            (click)="howItWorksIndex = 0" i18n>For Drivers</h4>
        <h4 class="h4-text cursor-pointer text-center" [ngClass]="howItWorksIndex == 1 ? 'selectedHowItWorks' : 'text-text-primary'"
            (click)="howItWorksIndex = 1" i18n>For Horse Owners</h4>
    </div>
    
    <div class="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <ng-container *ngIf="howItWorksIndex == 0">
            <app-feature-card imgSrc="assets/features/truck.webp" [title]="publishYourRideTitle" [text]="publishYourRideText"/>
            <app-feature-card imgSrc="assets/features/calendar.webp" [title]="receiveBookingsTitle" [text]="receiveBookingsText"/>
            <app-feature-card imgSrc="assets/features/chat.webp" [title]="coordinateDetailsTitle" [text]="coordinateDetailsText"/>
            <app-feature-card imgSrc="assets/features/cash.webp" [title]="saveMoneyTitle" [text]="saveMoneyText"/>
        </ng-container>
        <ng-container *ngIf="howItWorksIndex == 1">
            <app-feature-card imgSrc="assets/features/map.webp" [title]="findRideTitle" [text]="findRideText"/>
            <app-feature-card imgSrc="assets/features/calendar.webp" [title]="bookRideTitle" [text]="bookRideText"/>
            <app-feature-card imgSrc="assets/features/chat.webp" [title]="coordinateDetailsRiderTitle" [text]="coordinateDetailsRiderText"/>
            <app-feature-card imgSrc="assets/features/horse_in_truck.webp" [title]="travelTogetherTitle" [text]="travelTogetherText"/>
        </ng-container>
    </div>

    <ng-container *ngIf="user$ | async as userObject">
        <div *ngIf="!userObject.loggedIn" class="mt-10 flex flex-col md:flex-row justify-center items-center gap-4">
            <button routerLink="/register" class="primary-button w-full md:w-52" type="button" i18n="@@sign-up-action-button">Sign up</button>
        </div>  
    </ng-container>
</div>

<!-- <div class="bg-blue-50 px-5 lg:px-27 text-center rounded-lg shadow-lg pt-72 lg:pt-27 pb-16 lg:pb-20">
    <h2 class="text-text-primary h3-text sm:h2-text mb-4" i18n>Become an Early Bird</h2>
    <p class="body-m-text sm:body-l-text text-text-muted mb-6" i18n>Be the first to experience our new features and help us improve. Register now to participate in our beta testing program.</p>
    <div class="flex flex-col sm:flex-row justify-center items-center gap-4">
        <button routerLink="/register" class="primary-button w-full sm:w-auto" type="button" i18n>Register now</button>
        <span class="body-m-text" i18n="@@or-preposition">or</span>
        <button routerLink="/subscribe" class="secondary-button w-full sm:w-auto" type="button" i18n>Subscribe for updates</button>
    </div>
</div> -->
<!-- <div class="grid grid-cols-1 md:grid-cols-3 md:items-baseline gap-6
    pt-72 lg:pt-27 pb-16 lg:pb-20 px-5 lg:px-27 
    bg-white">
    <div class="flex flex-col items-center md:gap-2">
        <span class="text-text-primary h3-text sm:h2-text">30+</span>
        <span class="body-s-text sm:body-l-text text-text-muted text-center" i18n>Countries served</span>
    </div>
    <div class="flex flex-col items-center md:gap-2">
        <span class="text-text-primary h3-text sm:h2-text">200+</span>
        <span class="body-s-text sm:body-l-text text-text-muted text-center" i18n>Routes covered</span>
    </div>
    <div class="flex flex-col items-center md:gap-2">
        <span class="text-text-primary h3-text sm:h2-text">1000+</span>
        <span class="body-s-text sm:body-l-text text-text-muted text-center" i18n>Equestrian venues</span>
    </div>
</div> -->

<div class="md:h-[750px] 
    pt-14 lg:pt-27 
    pb-16 lg:pb-20 px-5 lg:px-27
    flex flex-col-reverse md:flex-row items-center gap-6 justify-between">
    <div class="lg:w-[500px]">
        <h2 class="text-text-primary h3-text sm:h2-text text-left mb-2" i18n>Ready for a Ride?</h2>
        <p class="body-m-text sm:body-l-text text-text-muted mb-6" i18n>Join our community of horse enthusiasts and reduce your expenses. Provide your ride details, and we'll handle the rest to ensure a smooth journey</p>
        <button routerLink="/new-ride" class="primary-button w-full md:w-auto" type="button" i18n>Create new ride</button>
    </div>
    <img class="h-72 md:h-80 lg:h-96 xl:h-130" src="assets/horse_in_truck.webp" alt="Horses in truck"/>
</div>

<!-- <app-competition-table></app-competition-table> -->